import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from "@angular/router";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {ToggleWebsiteSidebar} from "../../../store";
import {fromEvent} from "rxjs/internal/observable/fromEvent";
import {first, takeWhile} from "rxjs/operators";

@Component({
    selector: 'db-env-switcher',
    templateUrl: './env-switcher.component.html',
    styleUrls: ['./env-switcher.component.scss'],
    standalone: false
})
export class EnvSwitcherComponent implements OnInit, OnDestroy {

  @Input() currentEnv;
  @Input() websiteId: number;
  @Input() stagingEnabled: boolean;
  @Input() changingEnv: boolean;
  @Input() websiteSettingLoad: boolean;

  public toggled: boolean = false;

  private _clickOutside: Function;
  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _router: Router,
    private _renderer: Renderer2,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _element: ElementRef
  ) {}

  ngOnInit() {
  }

  ngOnDestroy() {
    this._clickOutside && this._clickOutside();
  }

  public toggleEnvSwitcher(): void {
    this.toggled = !this.toggled;
    if (this.toggled) {
      this.sentGAEvent('Dropdown Open');
    } else {
      this._store.dispatch(new ToggleWebsiteSidebar);
    }
    this._addEventListeners();
  }

  public changeEnvironment(changeEnv: 'live' | 'staging', manageEnv: boolean = false): void {
    this.toggleEnvSwitcher();
    if (this.currentEnv === changeEnv || this.changingEnv || this.websiteSettingLoad) {
      return;
    }

    this.sentGAEvent(changeEnv === 'live' ? 'Switch to Live' : manageEnv ? 'Staging Settings' : 'Switch to Staging');

    if (!this.stagingEnabled && this.currentEnv === 'live') {
      return this.redirectToEnableEnv();
    }

    this._router.navigate(
      [`/websites/${this.websiteId}/change-environment/${changeEnv === 'staging' ? 'live' : 'dev'}`],
      {queryParams: {manageEnv: manageEnv}, skipLocationChange: true, replaceUrl: true, }
    );
  }

  public redirectToManageEnv(): void {
    if (this.currentEnv === 'staging') {
      this.toggleEnvSwitcher();
      this.sentGAEvent('Staging Settings');
      this._router.navigate([`/websites/${this.websiteId}/hosting/manage-environment`]);
    } else {
      this.changeEnvironment('staging', true);
    }
  }

  private redirectToEnableEnv(): void {
    this._router.navigate([`/websites/${this.websiteId}/hosting/environment`]);
  }

  private sentGAEvent(label: 'Dropdown Open' | 'Switch to Live' | 'Switch to Staging' | 'Staging Settings') {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Staging Environment',
      eventLabel: label
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _addEventListeners(): void {
    fromEvent(document, 'click')
      .pipe(
        first(e => !this._element.nativeElement.contains(e.target)),
        takeWhile(() => this.toggled)
      )
      .subscribe(() => this.toggled = false);
  }
}
